import React from "react";

/**
 * Shared primitives used by multiple landing sections. Kept lightweight and
 * duplicated from `components/common/Primitives` so the Home page ships its
 * own visual language without cross-page style bleed.
 */
export function Pill({ children, tone = "navy", ...rest }) {
  const tones = {
    navy: "bg-white/5 border border-white/10 text-cream/85",
    gold: "bg-gold/10 border border-gold/30 text-gold",
    emerald: "bg-emerald-500/10 border border-emerald-400/30 text-emerald-300",
    rose: "bg-rose-500/10 border border-rose-400/30 text-rose-300",
    light: "bg-navy/[0.04] border border-navy/10 text-ink-soft",
  };
  return (
    <span className={`inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[11px] font-mono uppercase tracking-wider ${tones[tone]}`} {...rest}>
      {children}
    </span>
  );
}

export function SectionHeader({ eyebrow, title, subtitle, align = "left" }) {
  return (
    <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""} mb-10`}>
      {eyebrow && (
        <div className="text-[11px] font-mono uppercase tracking-[0.2em] text-gold mb-3">{eyebrow}</div>
      )}
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-[42px] leading-tight text-ink">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-ink-soft leading-relaxed max-w-2xl">
          {subtitle}
        </p>
      )}
    </div>
  );
}
